import { Component } from '@angular/core';

import { DocumentsSectionsHelper } from '@camelot/files-basic';
import { DocumentsAttachmentsModal } from '@camelot/files-extended';
import { InputAddressComponent } from '@camelot/form-input';
import { InputAddress } from '@camelot/form-model';

import { TestIdDirective } from '@camelot/testing-harness';

@Component({
    imports: [DocumentsAttachmentsModal, InputAddressComponent, TestIdDirective],
    template: `
    <cam-documents-attachments-modal-content
      camTestId="cam-documents-attachments-modal-content"
      [sectionsHelper]="this.sectionsHelper"
    />
    <cam-input-address camTestId="cam-input-address" [input]="this.address" [standalone]="true" />
  `
})
export class FilesModalCase {
  public address = new InputAddress({ key: 'address', label: 'Address' });
  public sectionsHelper = new DocumentsSectionsHelper([
    { emptyMessage: 'files.no-documents', key: 'documents', label: 'files.documents', order: 1 },
  ]);
}
